import { useContext } from 'react';
import { PreferencesContext } from 'providers/Preferences';

const usePreferences = () => useContext(PreferencesContext);

export default usePreferences;
